import React from 'react';
import { InstagramIcon, FacebookIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#241f28] py-14 text-white/70" data-id="element-40" data-mp="3gg10g6ubc3z8">
      <div className="mx-auto max-w-6xl px-6" data-id="element-41" data-mp="32o4c8dvrme84">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-42" data-mp="32pfg0dp7nlz8">
          <div data-id="element-43" data-mp="36pzb7bq84fiq">
            <p className="font-display text-xl font-semibold text-white" data-id="element-44" data-mp="36ppnjusnikg7">
              🎈 Decorá con Globos
            </p>
            <p className="mt-2 max-w-xs text-sm" data-id="element-45" data-mp="38qu4u3bljp2">
              Curso online de decoración con globos para cumpleaños y eventos.
            </p>
          </div>

          <nav className="flex flex-col gap-3 text-sm" data-id="element-46" data-mp="3ldu34pweqfur">
            <a href="#" className="transition hover:text-white" data-id="element-47" data-mp="3qcx9qes1cu4u">
              Términos y condiciones
            </a>
            <a href="#" className="transition hover:text-white" data-id="element-48" data-mp="29y5g5yj5lgty">
              Política de privacidad
            </a>
            <a href="https://wa.me/000000000" className="inline-flex items-center gap-2 transition hover:text-white" data-id="element-49" data-mp="2ezuvhqdesgnu">
              <MessageCircleIcon className="h-4 w-4" data-id="element-50" data-mp="3gaz2f4jbankm" />
              Contacto / WhatsApp
            </a>
          </nav>

          <div className="flex gap-3" data-id="element-51" data-mp="3v8rfzr5at1w6">
            {[{
            Icon: InstagramIcon,
            label: 'Instagram'
          }, {
            Icon: FacebookIcon,
            label: 'Facebook'
          }, {
            Icon: MessageCircleIcon,
            label: 'WhatsApp'
          }].map(({
            Icon,
            label
          }) => <a key={label} href="#" aria-label={label} className="grid h-10 w-10 place-items-center rounded-full bg-white/10 transition hover:bg-[#ec4899] hover:text-white" data-id="element-52" data-mp="34gvldp1el60">
                <Icon className="h-5 w-5" data-id="element-53" data-mp="cuihpzxtxtia" />
              </a>)}
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-white/45" data-id="element-54" data-mp="qrfba95c1p2v">
          © {new Date().getFullYear()} Decorá con Globos. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}